import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import env from "react-dotenv";

function ResetPassword() {
    let navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Change background color
        document.body.style.backgroundColor = "#f8f9fe"
    }, [])

    function handleChangePassword(event) {
        setPassword(event.target.value);
    }

    function handleChangePasswordConfirm(event) {
        setPasswordConfirm(event.target.value);
    }

    async function handleSubmit() {
        if (password !== passwordConfirm) {
            setErrorMessage("Les mots de passe ne correspondent pas.")
            return;
        }

        const params = new URLSearchParams(window.location.href.split("?")[1]);
        const id = params.get("id");
        const token = params.get("token");
        console.log(id);
        console.log(token);

        const res = await fetch(env.BACKEND_URL + "/admin/" + id + "/" + token, {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "password=" + password,
        });

        if (res.ok)
            navigate("/");
        else
            setErrorMessage("Erreur : " + await res.text());
    
    }


    return (
        <div>
            <div className="login">
                <div className="login-form">
                    <div className="login-error-text">
                        {errorMessage}
                    </div>

                    <div className="login-form-title">
                        Mot de passe
                    </div>
                    <div>
                        <input className="login-input-field" type="password" value={password} onChange={handleChangePassword} />
                    </div>

                    <div className="login-form-title">
                        Confirmer le mot de passe
                    </div>
                    <div>
                        <input className="login-input-field" type="password" value={passwordConfirm} onChange={handleChangePasswordConfirm} />
                    </div>

                    <div>
                        <button className="button" onClick={handleSubmit}>Envoyer</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;